import { Link } from 'react-router-dom';
import { heroStory } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroStory.imageUrl}
          alt={heroStory.title}
          className="w-full h-full object-cover object-top"
          title={heroStory.title}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-8 pt-32 pb-20 md:pt-40 md:pb-28 min-h-[520px] md:min-h-[620px]">
          <div className="w-full lg:w-1/2">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-full mb-4 whitespace-nowrap">
              突发爆料
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-background-50 leading-tight mb-4">
              {heroStory.title}
            </h1>
            <p className="text-sm md:text-base text-background-100/80 leading-relaxed mb-6 max-w-lg">
              {heroStory.excerpt}
            </p>
            <div className="flex items-center gap-4 flex-wrap">
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                阅读全文
                <i className="ri-arrow-right-line"></i>
              </Link>
              <span className="text-xs text-background-100/60 flex items-center gap-4">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {(heroStory.readCount / 10000).toFixed(0)}万阅读
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line"></i>
                  {(heroStory.commentCount / 10000).toFixed(0)}万评论
                </span>
              </span>
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex flex-col justify-end">
            <div className="flex items-center gap-3 text-background-100/60 text-xs">
              <span>{heroStory.date}</span>
              <span className="w-1 h-1 rounded-full bg-background-100/40"></span>
              <span>{heroStory.author}</span>
              <span className="w-1 h-1 rounded-full bg-background-100/40"></span>
              <Link
                to="/"
                className="text-background-100/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                #{heroStory.category}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}